export const ALERT_DEFAULT_SORT_VALUE = 'newest_item';
